import { render, staticRenderFns } from "./InfoClass.vue?vue&type=template&id=bb0be414&"
import script from "./InfoClass.vue?vue&type=script&lang=ts&"
export * from "./InfoClass.vue?vue&type=script&lang=ts&"
import style0 from "./InfoClass.vue?vue&type=style&index=0&id=bb0be414&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports